import { defineStyleConfig as e, defineStyle as n } from "@chakra-ui/react";
import { ThemeColorToken as o, ThemeSpaceToken as t, ThemeFontToken as m, ThemeFontSizeToken as i } from "../theme-tokens.js";
const r = n({
  fontSize: i.Medium,
  fontFamily: m.SubHeader,
  color: o.OnBackground,
  fontWeight: "normal",
  marginBottom: t.XSmall,
  _disabled: {
    opacity: 1,
    color: o.OnBackground
  }
}), f = e({
  baseStyle: r
});
export {
  f as formLabelConfig
};
